import { LANGUAGES_SUPPORTED, LanguagesSupported } from '@/types/enums';
import { LanguageInfo } from '@/types/language';
import { Route } from '@/types/routes';
import { PaginationState } from '@tanstack/react-table';
import { enUS, vi } from 'date-fns/locale';

// #region Routes
enum RoutesKey {
    home,
    dashboard,
    login,
    button,
    calendar,
    pagination,
    table,
    reactToastify,
    modal,
    tabs,
    userManagement,
    signUp,
    finishSignUp,
    profile,
    editProfile,
    qrProfile,
    termsOfService,
    privacyPolicy,
    faq,
    howToUse,
    inputEmail,
    inputOtp,
    listItems,
    setLocationItem,
    collectefItems,
    detailItemCollected,
    editRegisteredItem,
    registerNewItem,
    listNearBy,
    landing
};

export const ROUTES: Record<keyof typeof RoutesKey, Route> = {
    home: {
        href: '/home',
        title: 'words_title.home',
        menuLabel: 'words_title.home',
        breadcrumbLabel: 'words_title.home'
    },
    dashboard: {
        href: '/dashboard',
        title: 'words_title.dashboard',
        menuLabel: 'words_title.dashboard',
        breadcrumbLabel: 'words_title.dashboard'
    },
    landing: {
        href: '/',
        menuLabel: ''
    },
    login: {
        href: '/login',
        menuLabel: ''
    },
    button: {
        href: '/button',
        title: 'Button',
        menuLabel: 'Button',
        breadcrumbLabel: 'Button'
    },
    calendar: {
        href: '/calendar',
        title: 'Calendar',
        menuLabel: 'Calendar',
        breadcrumbLabel: 'Calendar'
    },
    pagination: {
        href: '/pagination',
        title: 'Pagination',
        menuLabel: 'Pagination',
        breadcrumbLabel: 'Pagination'
    },
    table: {
        href: '/table',
        title: 'Table',
        menuLabel: 'Table',
        breadcrumbLabel: 'Table'
    },
    reactToastify: {
        href: '/react-toastify',
        title: 'React Toastify',
        menuLabel: 'React Toastify',
        breadcrumbLabel: 'React Toastify'
    },
    modal: {
        href: '/modal',
        title: 'Modal',
        menuLabel: 'Modal',
        breadcrumbLabel: 'Modal'
    },
    tabs: {
        href: '/tabs',
        title: 'Tabs',
        menuLabel: 'Tabs',
        breadcrumbLabel: 'Tabs'
    },
    userManagement: {
        href: '/users',
        title: 'User Management',
        menuLabel: 'User Management',
        breadcrumbLabel: 'User Management'
    },
    signUp: {
        href: '/sign-up',
        menuLabel: ''
    },
    finishSignUp: {
        href: '/finish-sign-up',
        menuLabel: ''
    },
    profile: {
        href: '/profile',
        menuLabel: ''
    },
    editProfile: {
        href: '/edit-profile',
        menuLabel: ''
    },
    qrProfile: {
        href: '/qr-profile',
        menuLabel: ''
    },
    termsOfService: {
        href: '/terms',
        menuLabel: ''
    },
    privacyPolicy: {
        href: '/privacy-policy',
        menuLabel: ''
    },
    faq: {
        href: '/questions',
        menuLabel: ''
    },
    howToUse: {
        href: '/how-to-use',
        menuLabel: ''
    },
    inputEmail: {
        href: '/input-email',
        menuLabel: ''
    },
    inputOtp: {
        href: '/input-otp',
        menuLabel: ''
    },
    listItems: {
        href: '/list-items',
        menuLabel: ''
    },
    setLocationItem: {
        href: '/set-location',
        menuLabel: ''
    },
    collectefItems: {
        href: '/collected-items',
        menuLabel: ''
    },
    detailItemCollected: {
        href: '/detail-item-collected',
        menuLabel: ''
    },
    editRegisteredItem: {
        href: '/edit-registered-item',
        menuLabel: ''
    },
    registerNewItem: {
        href: '/t-register-new-item',
        menuLabel: ''
    },
    listNearBy: {
        href: '/items-near-by',
        menuLabel: ''
    }
};

// #endregion Routes

// #region Languages
export const DEFAULT_LANGUAGE: LanguagesSupported = LANGUAGES_SUPPORTED.English;

export const LANGUAGES_MAPPER: {
    english: LanguageInfo,
    vietnamese: LanguageInfo
} = {
    english: {
        code: LANGUAGES_SUPPORTED.English,
        fullname: 'words_title.english',
        shortName: 'EN',
        flag: 'gb',
        dateFns: enUS
    },
    vietnamese: {
        code: LANGUAGES_SUPPORTED.Vietnamese,
        fullname: 'words_title.vietnamese',
        shortName: 'VI',
        flag: 'vn',
        dateFns: vi
    }
};

// #endredion

// #region Dates

export const DATE_YMD = 'yyyy/MM/dd';

// #endregion

// #region Table

export const DEFAULT_SELECT_PAGE_SIZES: number[] = [10, 20, 50, 100, 200, 500, 1000];

export const DEFAULT_PAGINATION: PaginationState = {
    pageIndex: 0,
    pageSize: 10
};

export const STATE_AUTH_PARAMS =
    { lineLogin: 'lineLogin', lineSignUp: 'lineSignUp', xLogin: 'xLogin', xSignUp: 'xSignUp', googleLogin: 'googleLogin', googleSignUp: 'googleSignUp' }
    ;

// #endregion

export const TYPE_ACCOUNT = {
    GOOGLE: 'GOOGLE',
    TWITTER: 'TWITTER',
    LINE: 'LINE',
    PASSKEY: 'PASSKEY'
};

export const TYPE_ITEM_USE = {
    USED: 1,
    REMOVED: 2,
    ACQUISITION: 3,
    PUBLICY_REVERT: 4,
    RERASON: 5
};

export const ITEMS_CONST = {
    STATUS: {
        UN_PUBLISHED: 0,
        PUBLISHED: 1,
        PRIVATE: 2
    },
    ACTIVITY: {
        NONE: 1,
        PUBLISHED__ON_MAP: 2,
        PUBLISHED__GET_IT: 3,
        PUBLISHED__USED: 4,
        PUBLISHED__RESTORE: 5,
        PRIVATE__REPORT: 6,
        PRIVATE__WITHDRAWAL: 7,
        PRIVATE__EXPIRED: 8
    },
    ITEM_TYPE: {
        NOT_SET: 0,
        COUPON: 1
    },
    STATUS_REJECT: {
        NEVER_BEEN_REJECTED: 0, // chưa từng bị từ chối
        BEEN_REJECTED: 1 // đã từng bị từ chối
    },
    MAX_ITEMS_POST_ONE_DAY: 5
};
